import type { Pill } from 'features/libra/dashboard/ticketDashboard/types'
import type { LibraTicket } from 'features/libra/ticket/libraTicketsApi'
import { displayNameFromEmail } from 'utils/stringHelpers'

import { CREATOR_CATEGORY, VERSION_CATEGORY } from './categoryIds'

export function versionPill(ticket: LibraTicket): Pill {
  return {
    category: VERSION_CATEGORY,
    value: String(ticket.version),
    label: `V${ticket.version}`,
    icon: 'GitBranch',
  }
}

/** Keyed by email so two people with the same display name stay separate filter options. */
export function creatorPill(ticket: LibraTicket): Pill | undefined {
  if (!ticket.createdBy) return undefined
  return {
    category: CREATOR_CATEGORY,
    value: ticket.createdBy,
    label: displayNameFromEmail(ticket.createdBy),
    tooltip: ticket.createdBy,
    icon: 'User',
  }
}
